module.exports = __webpack_public_path__ + "static/img/3areaB_9.73007f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_9.png
// module id = 1172
// module chunks = 1